import { render, staticRenderFns } from "./order-add-or-update.vue?vue&type=template&id=2c8ea2b8&"
import script from "./order-add-or-update.vue?vue&type=script&lang=js&"
export * from "./order-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports